import React, { useEffect } from "react";
import {
  Nav, Hero, Marquee, Problem, Agitation, SolutionIntro,
  HowItWorks, Features, Audience, SocialProof, Pricing,
  ObjectionCrusher, ClosingCta, Footer,
} from "./landing/LandingSections";

export default function Landing() {
  useEffect(() => {
    // Capture ref code from any ?ref=XYZ marketing link so the eventual signup
    // can credit the referrer. Silent-fail on private/locked-down browsers.
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      try {
        localStorage.setItem("vl_ref_code", ref);
        localStorage.setItem("vl_ref_at", Date.now().toString());
      } catch { /* ignore: localStorage unavailable */ }
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Nav />
      <Hero />
      <Marquee />
      <Problem />
      <Agitation />
      <SolutionIntro />
      <HowItWorks />
      <Features />
      <Audience />
      <SocialProof />
      <Pricing />
      <ObjectionCrusher />
      <ClosingCta />
      <Footer />
    </div>
  );
}
